import axios from 'axios';
import { omit } from 'ramda';

import { BASE_URL } from 'constants/urls';

axios.defaults.timeout = 5 * 60 * 1000;

export function setBaseUrl(base = BASE_URL) {
    axios.defaults.baseURL = base;
}

export function addDefaultHeader(header, value) {
    axios.defaults.headers.common[header] = value;
};

export function removeDefaultHeader(header) {
    omit([header], axios.defaults.headers.common);
};

class HttpError {
    constructor(error) {
        const { response = {} } = error;

        this.origin = error;

        this.data = response.data;
        this.status = response.status;
    }
}

const errorHandler = (error) => {
    const httpError = new HttpError(error);
    return Promise.reject(httpError);
};

export function provideRequestInterceptors() {
    axios.interceptors.request.use(
        config => config,
        errorHandler
    );
}

export function provideResponseInterceptors() {
    axios.interceptors.response.use(
        response => response.data,
        errorHandler
    );
}



// WEBPACK FOOTER //
// ./src/utils/http.js